import { Box, IconButton, Modal } from "@mui/material";
import { APP_COLOR } from "../../theme";
import { messageModalStyles } from "./styles";
import CloseIcon from "@mui/icons-material/Close";
import CustomButton from "../CustomButton/CustomButton";

const DeleteConfirmationModal: React.FC<{
  message: string;
  toggle: () => void;
  isMessageModalOpen: boolean;
  handleConfirm: () => void;
  loading?: boolean;
}> = ({ message, toggle, isMessageModalOpen, handleConfirm, loading }) => {
  return (
    <>
      <Modal
        open={isMessageModalOpen}
        onClose={toggle}
        style={messageModalStyles.modal}
      >
        <Box style={messageModalStyles.postMessageModal}>
          <IconButton
            onClick={toggle}
            style={messageModalStyles.postMessageModalIcon}
          >
            <CloseIcon style={{ color: APP_COLOR }} />
          </IconButton>
          <Box style={messageModalStyles.messageBox}>{message}</Box>
          <Box sx={messageModalStyles.modalBox}>
            <CustomButton
              text="Confirm"
              onClick={handleConfirm}
              customStyles={{ width: "48%" }}
              loading={loading}
            />
            <CustomButton
              text="Dismiss"
              onClick={toggle}
              isSkipButton={true}
              customStyles={{ width: "48%" }}
            />
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default DeleteConfirmationModal;
